<div class="popover component">
  <div class="popover-body">
    @if (popoverInput.templateRef) {
    <ng-container
      [ngTemplateOutlet]="popoverInput.templateRef"
      [ngTemplateOutletContext]="popoverInput.data"
    >
    </ng-container>
    } @if (popoverInput.component) {
    <ng-container [ngComponentOutlet]="popoverInput.component"> </ng-container>
    }
  </div>
</div>
